module.exports = __webpack_public_path__ + "static/media/16loikhuyen.13d6fe3b.jpg";